import React from "react";
import { Card, Grid, Typography } from "@mui/material";

const sharedCardStyle = {
  px: 3,
  py: 2,
  minHeight: 90,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: "#f9f9f9",
  boxShadow: 1,
  borderRadius: 2,
};

const formatCurrency = (value) => `$${parseFloat(value).toFixed(2)}`;

const BillingSummaryCards = ({ data }) => {
  const totalBilled = data
    .filter((item) => item.billable)
    .reduce((sum, item) => sum + parseFloat(item.price || 0), 0);

  const uniqueWorkOrders = new Set();
  data.forEach((item) => {
    if (!item.billable) return;
    let key = null;
    if (item.work_order_id && item.billable_request_id) {
      key = `wo-${item.work_order_id}-br-${item.billable_request_id}`;
    } else if (item.work_order_id) {
      key = `wo-${item.work_order_id}`;
    } else if (item.violation_id) {
      key = `violation-${item.violation_id}`;
    } else if (item.architectural_request_id) {
      key = `arch-${item.architectural_request_id}`;
    } else if (item.general_request_id) {
      key = `gen-${item.general_request_id}`;
    }
    if (key) uniqueWorkOrders.add(key);
  });

  const billedWOCount = uniqueWorkOrders.size;
  const averagePerWO = billedWOCount > 0 ? totalBilled / billedWOCount : 0;

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={4}>
        <Card sx={sharedCardStyle}>
          <Typography variant="body2" color="text.secondary">
            💰 Total Billed Amount
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {formatCurrency(totalBilled)}
          </Typography>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Card sx={sharedCardStyle}>
          <Typography variant="body2" color="text.secondary">
            📦 Work Orders Billed
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {billedWOCount}
          </Typography>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Card sx={sharedCardStyle}>
          <Typography variant="body2" color="text.secondary">
            📊 Avg $ per WO
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {formatCurrency(averagePerWO)}
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BillingSummaryCards;
